import {Action} from '@ngrx/store';


export const AKTUELLE_VORLAGE_ID_SETZEN = '[VorlageAuswaehlenPage] Aktuelle VorlagenId Setzen';
export const PAGE_STATE_RESET = '[VorlageAuswaehlenPage] Page State reset';
export const IGNORE_WS_ACTION = '[VorlageAuswaehlenPage] WS Action ignoriert';
export const REFRESH_DATA = '[VorlageAuswaehlenPage] Refresh Data';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// IGNORE WS ACTION
export class IgnoreWSAction implements Action {
    readonly type = IGNORE_WS_ACTION;

    constructor(public payload: any) {
    }
}

export class AktuelleVorlageIdSetzenAction implements Action {
    readonly type = AKTUELLE_VORLAGE_ID_SETZEN;

    constructor(public payload: string) {
    }
}

export class RefreshDataAction implements Action {
    readonly type = REFRESH_DATA;
}

export type Actions =
    PageStateResetAction
    | IgnoreWSAction
    | AktuelleVorlageIdSetzenAction
    | RefreshDataAction
    ;
